import React from 'react';

const NotFound = () => {
  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <div className="page-header">
            <h1>Page Not Found</h1>
          </div>
        </div>
      </div>

      <div className="mhd-container-content-wrapper">
        <h3>This page was not found.</h3>
      </div>
    </div>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js